import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';
import '../components/AdminLayout.css';

function fmtDate(d) { return d ? new Date(d).toLocaleDateString('tr-TR') : '-'; }

function statusBadge(s) {
  const map = { completed: ['badge-green', 'Tamamlandı'], pending: ['badge-orange', 'Bekliyor'], cancelled: ['badge-red', 'İptal'], accepted: ['badge-green', 'Onayladı'], rejected: ['badge-red', 'Reddetti'] };
  const [cls, label] = map[s] || ['badge-gray', s || '-'];
  return <span className={`badge ${cls}`}>{label}</span>;
}

export default function Matches() {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [selectedMatch, setSelectedMatch] = useState(null);

  useEffect(() => { fetchMatches(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function fetchMatches() {
    setLoading(true);
    try {
      const { data: rawMatches, error } = await supabase
        .from('matches')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) { console.error('Matches error:', error); setLoading(false); return; }

      const userIds = [...new Set((rawMatches || []).flatMap(m => [m.user_a_id, m.user_b_id]).filter(Boolean))];
      const noteIds = [...new Set((rawMatches || []).flatMap(m => [m.a_offer_note_id, m.a_search_note_id, m.b_offer_note_id, m.b_search_note_id]).filter(Boolean))];

      let profileMap = {}, noteMap = {};

      if (userIds.length > 0) {
        const { data: profiles } = await supabase.from('profiles').select('id, name, email').in('id', userIds);
        if (profiles) profiles.forEach(p => { profileMap[p.id] = p; });
      }
      if (noteIds.length > 0) {
        const { data: notes } = await supabase.from('notes').select('id, title, course').in('id', noteIds);
        if (notes) notes.forEach(n => { noteMap[n.id] = n; });
      }

      let enriched = (rawMatches || []).map(m => ({
        ...m,
        user_a: profileMap[m.user_a_id] || null,
        user_b: profileMap[m.user_b_id] || null,
        note_a_offer: noteMap[m.a_offer_note_id] || null,
        note_a_search: noteMap[m.a_search_note_id] || null,
        note_b_offer: noteMap[m.b_offer_note_id] || null,
        note_b_search: noteMap[m.b_search_note_id] || null,
      }));

      if (filterStatus) enriched = enriched.filter(m => m.final_status === filterStatus);
      if (search) enriched = enriched.filter(m =>
        (m.user_a?.name || '').toLowerCase().includes(search.toLowerCase()) ||
        (m.user_b?.name || '').toLowerCase().includes(search.toLowerCase())
      );
      setMatches(enriched);
    } catch (e) { console.error(e); }
    setLoading(false);
  }

  return (
    <div>
      <div className="admin-filter-bar">
        <input className="admin-search-input" placeholder="Kullanıcı ile ara..." value={search} onChange={e => setSearch(e.target.value)} />
        <select className="admin-select" value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
          <option value="">Tüm Durumlar</option>
          <option value="completed">Tamamlandı</option>
          <option value="pending">Bekliyor</option>
          <option value="cancelled">İptal</option>
        </select>
        <button className="btn-admin btn-admin-primary" onClick={fetchMatches}>Filtrele</button>
      </div>

      <div className="admin-table-wrapper">
        <div className="admin-table-scroll">
          <table className="admin-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Kullanıcı A</th>
                <th>Kullanıcı B</th>
                <th>A Teklif</th>
                <th>A Arama</th>
                <th>A Durum</th>
                <th>B Durum</th>
                <th>Son Durum</th>
                <th>Tarih</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr className="admin-loading-row"><td colSpan={9}>Yükleniyor...</td></tr>
              ) : matches.length === 0 ? (
                <tr className="admin-loading-row"><td colSpan={9}>Eşleşme bulunamadı.</td></tr>
              ) : matches.map(m => (
                <tr key={m.id}>
                  <td>
                    <button style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#5784E6', fontWeight: 600, padding: 0, fontSize: '0.8rem', fontFamily: 'inherit' }} onClick={() => setSelectedMatch(m)}>
                      {m.id.slice(0, 8)}...
                    </button>
                  </td>
                  <td><strong>{m.user_a?.name || '-'}</strong></td>
                  <td>{m.user_b?.name || '-'}</td>
                  <td>{m.note_a_offer?.course || '-'}</td>
                  <td>{m.note_a_search?.course || '-'}</td>
                  <td>{statusBadge(m.a_status)}</td>
                  <td>{statusBadge(m.b_status)}</td>
                  <td>{statusBadge(m.final_status)}</td>
                  <td>{fmtDate(m.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="admin-table-footer">Toplam {matches.length} eşleşme gösteriliyor</div>
      </div>

      {selectedMatch && (
        <div className="admin-drawer-overlay" onClick={() => setSelectedMatch(null)}>
          <div className="admin-drawer" onClick={e => e.stopPropagation()}>
            <div className="admin-drawer-header">
              <h3>Eşleşme Detayı</h3>
              <button className="admin-drawer-close" onClick={() => setSelectedMatch(null)}>✕</button>
            </div>
            <div className="admin-drawer-body">
              <div className="detail-row"><label>Eşleşme ID</label><span style={{ fontSize: '0.75rem', wordBreak: 'break-all' }}>{selectedMatch.id}</span></div>
              <div className="detail-row"><label>Son Durum</label><span>{statusBadge(selectedMatch.final_status)}</span></div>
              <div className="detail-row"><label>Oluşturulma</label><span>{fmtDate(selectedMatch.created_at)}</span></div>
              <hr className="detail-divider" />
              <div style={{ background: '#F4F6FF', borderRadius: 12, padding: '14px 16px', marginBottom: 4 }}>
                <p style={{ fontSize: '0.75rem', fontWeight: 700, color: '#5784E6', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.3px' }}>Kullanıcı A</p>
                <div className="detail-row"><label>İsim</label><span>{selectedMatch.user_a?.name || '-'}</span></div>
                <div className="detail-row"><label>E-posta</label><span>{selectedMatch.user_a?.email || '-'}</span></div>
                <div className="detail-row"><label>Teklif Notu</label><span>{selectedMatch.note_a_offer?.title || '-'}</span></div>
                <div className="detail-row"><label>Aradığı Not</label><span>{selectedMatch.note_a_search?.title || '-'}</span></div>
                <div className="detail-row"><label>Durum</label><span>{statusBadge(selectedMatch.a_status)}</span></div>
              </div>
              <div style={{ background: '#FFF8E6', borderRadius: 12, padding: '14px 16px' }}>
                <p style={{ fontSize: '0.75rem', fontWeight: 700, color: '#FFB400', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.3px' }}>Kullanıcı B</p>
                <div className="detail-row"><label>İsim</label><span>{selectedMatch.user_b?.name || '-'}</span></div>
                <div className="detail-row"><label>E-posta</label><span>{selectedMatch.user_b?.email || '-'}</span></div>
                <div className="detail-row"><label>Teklif Notu</label><span>{selectedMatch.note_b_offer?.title || '-'}</span></div>
                <div className="detail-row"><label>Aradığı Not</label><span>{selectedMatch.note_b_search?.title || '-'}</span></div>
                <div className="detail-row"><label>Durum</label><span>{statusBadge(selectedMatch.b_status)}</span></div>
              </div>
              <hr className="detail-divider" />
              <p style={{ fontSize: '0.78rem', color: '#7A8BAD', lineHeight: 1.6, background: '#F4F6FF', padding: '10px 12px', borderRadius: 8 }}>
                <strong>Eşleşme Mantığı:</strong> A kullanıcısı bir not sunar ve başka bir not arar. B kullanıcısı A'nın aradığı notu sunar ve A'nın sunduğu notu arar. Her iki taraf da onayladığında eşleşme tamamlanır.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
